/** Een icoon dat de server al als SVG heeft gerenderd
 *  (server/services/icon-svg.ts). Vervangt TaxonomyIcon op de publieke site:
 *  die trok de hele lucide-bibliotheek de homepage in. De markup komt uit
 *  onze eigen afhankelijkheid, nooit uit gebruikersinvoer. */
export function IconSvg({ svg, className }: { svg?: string | null; className?: string }) {
  if (!svg) return null;
  return <span className={className ?? 'inline-flex'} aria-hidden dangerouslySetInnerHTML={{ __html: svg }} />;
}
